export default {
      id: "left-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.ece5aa3c.svg#left",
      toString: function () {
        return this.url;
      }
    }